
window.onerror = function (msg, url, lineNo, columnNo, error) {
    logGaError(msg, url, lineNo, columnNo, error)
}

window.gtm = {
    errors: {
        "repeated": false
    },
    trackDigital: function (element) {
        var name = element.href.substr(element.href.lastIndexOf("/") + 1, element.href.length);
        name = name.indexOf("?") != -1 ? name.split("?")[0] : name;
        name = name.replace(/_/g, " ");
        var pageType = "";

        try {
            pageType = JSON.parse(document.getElementById('shop-js-analytics').innerHTML).pageType
        }
        catch (e) {
            console.log("error getting page type");
        }
        var model = {
            "event": "digital brochure view",
            "eventModel": {
                "name": name,
                "pageType": pageType

            }
        }
        window.dataLayer.push(model);

    }

}

repeated = false;
function logGaError(msg, url, lineNo, columnNo, error) {
    var data = {};
    // data.userAgent = window.navigator.userAgent;
    data.screenWidth = window.innerWidth;
    data.message = msg;
    if (typeof (ga) == "function") {

        var x = {
            "event": "javascript_errors",
            "eventData": {
                "event_category": 'javascript_errors',
                "event_action": window.location.href,
                "event_label": JSON.stringify(data)
            }
        }

        window.dataLayer.push(x);


    }
    else {
        if (window.gtm.errors.repeated == true) {
            return;
        }
        // repeat
        setTimeout(function () {
            logGaError(msg, url, lineNo, columnNo, error);
            window.gtm.errors.repeated = true;
        }, 2000)
    }

}

(function () {
    var getItem = sessionStorage.getItem("landing_page");
    if (getItem == null) {
        var model = {
            "event": "landingPage",
            "landingPageUrl": window.location.href,
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(model);
        sessionStorage.setItem("landing_page", window.location.href);
    }
})();




(function () {
    if (window.location.href.indexOf('why-neptune?makers-mark=true') != -1) {
        window.addEventListener("load", (e) => {
            gtag("event", "makers_mark", {
                'event_category': 'makers_mark',
                'event_action': window.location.href,
                'event_label': "true",
                'value': 0
            });
        })
    }
})();



(function () {
    try {
        var cartCookie = document.cookie.split(';').filter(e => e.indexOf('cart=') != -1);
        if (cartCookie.length > 0 && sessionStorage.getItem("shopping_basket_id") == null) {
            sessionStorage.setItem("shopping_basket_id", "true");
            gtag("event", "shopping_basket_id", {
                'event_category': 'shopping_basket_id',
                'event_action': window.location.href,
                'shopping_basket_id': cartCookie[0].split('=')[1].trim(),
                'event_label': cartCookie[0].split('=')[1].trim(),
                'value': 0
            });
        }
    }
    catch (ex) {

    }
})();





window.addEventListener('load', function () {

    if (window["ShopifyProduct"] != null) {
        var isUnavail = ShopifyProduct.filter(e => e.inventory.available < 1 && e.inventory.policy == "deny")

        if (isUnavail.length > 0) {
            document.querySelector('.js-add-to-cart').addEventListener('click', (e) => {
                e.stopImmediatePropagation();
                variant = ShopifyProduct[0];
                if (window.location.href.indexOf('variant=') != -1) {
                    var id = window.location.href.split('variant=')[1];
                    if (id.indexOf("&") != -1) {
                        id = id.split("&")[0];
                    }
                    variant = ShopifyProduct.find(b => b.id == id);
                }
                if (variant.inventory.available < 1 && variant.inventory.policy == "deny") {
                    window.neptune.hj('event', 'zero_available_quantity');
                    console.log("hj:zero_available_quantity")
                }
            })

        }


    }

})